const Heading = ({ text }) => {
    return (
        <h1 className="text-semilarge text-center font-display font-bold capitalize text-primary-700">
            {text}
        </h1>
    )
}

export default Heading
